/**
 * NS Matching Config
 */

export const NS_SAVE_MATCHING_CONFIG_DATA = 'NS_SAVE_MATCHING_CONFIG_DATA';
export const NS_SAVE_MATCHING_CONFIG_DATA_TO_REDUX =
  'NS_SAVE_MATCHING_CONFIG_DATA_TO_REDUX';
export const NS_GET_MATCHING_CONFIG_PARAMATERS_DATA =
  'NS_GET_MATCHING_CONFIG_PARAMATERS_DATA';
export const NS_GET_MATCHING_CONFIG_PARAMATERS_SUCCESS =
  'NS_GET_MATCHING_CONFIG_PARAMATERS_SUCCESS';
export const NS_GET_MATCHING_CONFIG_PARAMATERS_FAIL =
  'NS_GET_MATCHING_CONFIG_PARAMATERS_FAIL';

export const NS_GET_MATCHING_CONFIG_RISK_INDICATORS_DATA =
  'NS_GET_MATCHING_CONFIG_RISK_INDICATORS_DATA';
export const NS_GET_MATCHING_CONFIG_RISK_INDICATORS_SUCCESS =
  'NS_GET_MATCHING_CONFIG_RISK_INDICATORS_SUCCESS';
export const NS_GET_MATCHING_CONFIG_RISK_INDICATORS_FAIL =
  'NS_GET_MATCHING_CONFIG_RISK_INDICATORS_FAIL';

export const NS_GET_MATCHING_CONFIG_LIST = 'NS_GET_MATCHING_CONFIG_LIST';
export const NS_GET_MATCHING_CONFIG_LIST_FAIL =
  'NS_GET_MATCHING_CONFIG_LIST_FAIL';
export const NS_GET_MATCHING_CONFIG_LIST_SUCCESS =
  'NS_GET_MATCHING_CONFIG_LIST_SUCCESS';

export const NS_POST_CREATE_MATCHING_CONFIG = 'NS_POST_CREATE_MATCHING_CONFIG';
export const NS_POST_CREATE_MATCHING_CONFIG_SUCCESS =
  'NS_POST_CREATE_MATCHING_CONFIG_SUCCESS';
export const NS_POST_CREATE_MATCHING_CONFIG_FAIL =
  'NS_POST_CREATE_MATCHING_CONFIG_FAIL';

export const NS_GET_MATCHING_CONFIG_BY_ID = 'NS_GET_MATCHING_CONFIG_BY_ID';
export const NS_GET_MATCHING_CONFIG_BY_ID_SUCCESS =
  'NS_GET_MATCHING_CONFIG_BY_ID_SUCCESS';
export const NS_GET_MATCHING_CONFIG_BY_ID_FAIL =
  'NS_GET_MATCHING_CONFIG_BY_ID_FAIL';

export const NS_GET_MATCHING_CONFIG = 'NS_GET_MATCHING_CONFIG';
export const NS_GET_MATCHING_CONFIG_SUCCESS = 'NS_GET_MATCHING_CONFIG_SUCCESS';
export const NS_GET_MATCHING_CONFIG_FAIL = 'NS_GET_MATCHING_CONFIG_FAIL';

export const NS_PUT_UPDATE_MATCHING_CONFIG = 'NS_PUT_UPDATE_MATCHING_CONFIG';
export const NS_PUT_UPDATE_MATCHING_CONFIG_SUCCESS =
  'NS_PUT_UPDATE_MATCHING_CONFIG_SUCCESS';
export const NS_PUT_UPDATE_MATCHING_CONFIG_FAIL =
  'NS_PUT_UPDATE_MATCHING_CONFIG_FAIL';

export const NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST =
  'NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST';
export const NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_SUCCESS =
  'NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_SUCCESS';
export const NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_FAIL =
  'NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_FAIL';

export const getNSMatchingConfigRiskIndicatorparameters = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_RISK_INDICATORS_DATA,
    payload
  };
};

export const getNSMatchingConfigRiskIndicatorParametersSuccess = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_RISK_INDICATORS_SUCCESS,
    payload
  };
};

export const getNSMatchingConfigRiskIndicatorParametersFail = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_RISK_INDICATORS_FAIL,
    payload
  };
};

export const getNSMatchingConfigRiskIndicatorList = () => {
  return {
    type: NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST
  };
};

export const getNSMatchingConfigRiskIndicatorListSuccess = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_SUCCESS,
    payload
  };
};

export const getNSMatchingConfigRiskIndicatorListFail = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST_FAIL,
    payload
  };
};

export const saveNSMatchingConfigToStore = (payload) => {
  return {
    type: NS_SAVE_MATCHING_CONFIG_DATA,
    payload
  };
};

export const saveMatchingConfigToRedux = (payload) => {
  return {
    type: NS_SAVE_MATCHING_CONFIG_DATA_TO_REDUX,
    payload
  };
};

export function getMatchingConfigParametersData(payload) {
  return {
    type: NS_GET_MATCHING_CONFIG_PARAMATERS_DATA,
    payload
  };
}

export function getMatchingConfigParametersDataSuccess(payload) {
  return {
    type: NS_GET_MATCHING_CONFIG_PARAMATERS_SUCCESS,
    payload
  };
}
export const getNSMatchingConfigListData = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_LIST,
    payload
  };
};

export const getNSMatchingConfigListDataSuccess = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_LIST_SUCCESS,
    payload
  };
};

export const getNSMatchingConfigListDataFail = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_LIST_FAIL,
    payload
  };
};

export const postNSCreateMatchingConfig = (payload) => {
  return {
    type: NS_POST_CREATE_MATCHING_CONFIG,
    payload
  };
};

export const postNSCreateMatchingConfigSuccess = (payload) => {
  return {
    type: NS_POST_CREATE_MATCHING_CONFIG_SUCCESS,
    payload
  };
};

export const postNSCreateMatchingConfigFail = (payload) => {
  return {
    type: NS_POST_CREATE_MATCHING_CONFIG_FAIL,
    payload
  };
};

export const getNSMatchingConfigById = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_BY_ID,
    payload
  };
};

export const getNSMatchingConfigByIdSuccess = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_BY_ID_SUCCESS,
    payload
  };
};

export const getNSMatchingConfigByIdFail = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_BY_ID_FAIL,
    payload
  };
};

export const getNSMatchingConfig = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG,
    payload
  };
};

export const getNSMatchingConfigSuccess = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_SUCCESS,
    payload
  };
};

export const getNSMatchingConfigFail = (payload) => {
  return {
    type: NS_GET_MATCHING_CONFIG_FAIL,
    payload
  };
};

export const putNSUpdateMatchingConfig = (payload) => {
  return {
    type: NS_PUT_UPDATE_MATCHING_CONFIG,
    payload
  };
};

export const putNSUpdateMatchingConfigSuccess = (payload) => {
  return {
    type: NS_PUT_UPDATE_MATCHING_CONFIG_SUCCESS,
    payload
  };
};

export const putNSUpdateMatchingConfigFail = (payload) => {
  return {
    type: NS_PUT_UPDATE_MATCHING_CONFIG_FAIL,
    payload
  };
};
